import React from 'react';
import {HashRouter, Switch, Route} from 'react-router-dom';
import Main from './pages/main';
import Evento from './pages/evento';


const Routes = () => (

        <HashRouter>
            <Switch>
                <Route exact path="/" component={Main}></Route>
                <Route path="/eventos/:id" component={Evento}></Route>

            </Switch>
        
        
        </HashRouter>

)

export default Routes;